import type { SafeAny, TrulyString } from '@/common/types';

export enum EpochGraphTypes {
  default = 0,
  oneLine = 1,
  multipleLines = 2,
  bar = 3,
  scatter = 4
}

export type EpochModifierType = 'epoch' | 'epochSize';

export interface SignalConfig {
  defaultOffset: number;
  defaultScale: number;
  max: number;
  min: number;
  unit: string;
  vizmode?: EpochGraphTypes;
}

export interface EpochData {
  mapping: {
    [key: string]: SignalConfig;
  };
  signal: {
    [key: string]: ([number] | [number, number])[];
  };
}

export interface EpochParams {
  id: string;
  epochSize: SafeAny;
  notch?: TrulyString;
  band?: TrulyString;
  epochSelected: SafeAny;
}

export interface ScoreSetEvent {
  id: string;
  start: string;
  duration: number;
  startEpoch: number;
  endEpoch: number;
}

export interface ScoreSetEventsData {
  [key: string]: ScoreSetEvent[];
}
